/**
 * TAF协议映射，此文件依赖 TafProtocol.js
 */
import HUYA from './TafProtocol';

var TafMx = {};

TafMx.UriMapping = {
    ...TafMx.UriMapping,
    //机器要下线 , 服务端下发的重定向请求
    "1025305": HUYA.WSRedirect
};

TafMx.WupMapping = {
    ...TafMx.WupMapping,
    "wsLaunch": HUYA.WSLaunchRsp,
    "queryHttpDns": HUYA.QueryHttpDnsRsp
};

export default TafMx;